export default __webpack_public_path__ + "static/gym-820724e00451672e0a7579b3987f785d.jpg";